import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { Outlet } from 'react-router-dom';
import style from './TeamsLayoutContainer.module.css.js';

const TeamsLayoutContainer = ({ children, sidebarOpen, setSidebarOpen }) => {
    return (jsxs("div", { className: classNames(style.container, sidebarOpen && style.open), children: [jsx("div", { className: classNames(style.sidebar, sidebarOpen && style.sidebarOpen), children: children }), jsx("div", { className: style.page, onClick: () => sidebarOpen && setSidebarOpen(false), children: jsx(Outlet, {}) })] }));
};

export { TeamsLayoutContainer };
//# sourceMappingURL=TeamsLayoutContainer.js.map
